import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { NFTScrollItem } from "./NFTScrollItem";
import { MyWalletResourcePackage } from "../../../resources/MyWalletResourcePackage";
import { Graphics, Sprite, Texture } from "pixi.js";
import { BuildingPiggyMultiplier } from "../../BuildingPiggyMultiplier";
import { PiggyClubSupportedBuildings } from "../../PiggyClubSupportedBuildings";
import { NFTPiggyClub } from "by/gamefactory/web3/nfts/NFTPiggyClub";

export class NFTPiggyClubScrollItem extends NFTScrollItem {
    private readonly borderMask: Graphics;
    private readonly bottomLight: Sprite;
    private readonly piggyMultiplier: BuildingPiggyMultiplier;
    private readonly supportedBuildings: PiggyClubSupportedBuildings;

    public constructor(
        commonResources: CommonResourcesPackage,
        myWalletResources: MyWalletResourcePackage,
        piggyClubTexture: Texture,
        data: NFTPiggyClub,
        options: PiggyClubScrollItemOptions
    ) {
        super(piggyClubTexture, data);
        this.borderMask = new Graphics();
        this.borderMask.beginFill();
        this.borderMask.drawRoundedRect(0, 0, this.image.width, this.image.height, 25);
        this.borderMask.endFill();
        this.addChild(this.borderMask);
        this.image.mask = this.borderMask;

        this.bottomLight = new Sprite(myWalletResources.assets_views_my_wallet_ui_horizontal_light_png);
        this.bottomLight.position.set((this.image.width - this.bottomLight.width) * 0.5, this.image.height);

        this.piggyMultiplier = new BuildingPiggyMultiplier(commonResources, `+${Math.round(((options.piggyMuiltiplier - 1) * 100))}%`);
        this.supportedBuildings = new PiggyClubSupportedBuildings(commonResources, options.supportedBuildingsCount);
        this.piggyMultiplier.visible = options.piggyMuiltiplier != 1;

        if (options.piggyMuiltiplier != 1) {
            this.piggyMultiplier.position.set(95, this.image.height + 21);
            this.supportedBuildings.position.set(264, this.image.height + 21);
        } else {
            this.supportedBuildings.position.set((this.width - this.supportedBuildings.width) * 0.5, this.image.height + 21);
        }

        this.addChild(
            this.bottomLight,
            this.piggyMultiplier,
            this.supportedBuildings
        );
    }
}

export type PiggyClubScrollItemOptions = {
    piggyMuiltiplier: number;
    supportedBuildingsCount: number;
}
